import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formStyleConstants } from '../../utils/constants/form-style-constants';
import ReCAPTCHA from "react-google-recaptcha";
import app from '../../../../../general/js/app';

class FormCaptchaField extends Component {
    constructor(props) {
        super(props);
        const { validState } = this.props;

        this.initialState = {
            isValid: true,
            errorMessage: ''
        };
        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }
        this.state = this.initialState;
    }

    render() {
        const {
            validState,
            formRef,
            onChange,
            isHidden
        } = this.props;

        const { isValid, errorMessage } = validState || this.state;
        const fieldClassName = formStyleConstants.customFieldClassName;
        const recaptchaPublicKey = app.state.recaptchaPublicKey;
        const recaptchaStyle = {
            marginTop: '15px',
            display: isHidden ? 'none' : 'block'
        }

        return (
            <Fragment>
                <div
                    className={`form-field auto-mt-xs ${fieldClassName.toLowerCase()}-field`}
                    data-dc-component='form-field'
                    data-form-control
                    style={recaptchaStyle}
                >

                    <ReCAPTCHA
                        sitekey={recaptchaPublicKey}
                        onChange={onChange}
                        ref={formRef} />

                    {!isValid ? <ul className="form-field__error-list filled">
                        <li className="form-field__error-item">{errorMessage}</li>
                    </ul> : null}
                </div>
            </Fragment>
        );
    }
}

FormCaptchaField.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    isHidden: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    validState: PropTypes.object,
};

export default FormCaptchaField;
